<script setup name="ZoomEmailCalendarDetails">
import ZoomLogo from '@/assets/plans/logo_zoom.svg';
import FeatureCheck from '@/assets/plans/re-checked.svg';
import PriceList from '@/components/price-list.vue';
import BillingDialog from '@/components/billing-dialog.vue';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:visible']);
</script>
<template>
<billing-dialog 
  :modelValue="visible" 
  @update:modelValue="emit('update:visible', $event)" 
  show-close 
  class="zoom-email-calendar-details" 
  :style="{ '--feature-check-url': `url(${FeatureCheck})` }"
  @back-event="emit('update:visible', false)"
>
  <div class="zoom-email-calendar-details__content">
    <div class="zoom-email-calendar-details__header">
      <img :src="ZoomLogo" alt="" class="zoom-email-calendar-details__logo">
      <h1 class="zoom-email-calendar-details__title">
        {{ $t('billing.zoom_email_calendar.title') }}
      </h1>
    </div>
    <div class="zoom-email-calendar-details__price">
      <price-list plan-category="zmailcal" />
    </div>
    <ul class="zoom-email-calendar-details__features">
      <li class="zoom-email-calendar-details__feature">{{ $t('billing.zoom_email_calendar.feature-1') }}</li>
      <li class="zoom-email-calendar-details__feature">{{ $t('billing.zoom_email_calendar.feature-2') }}</li>
      <li class="zoom-email-calendar-details__feature">{{ $t('billing.zoom_email_calendar.feature-3') }}</li>
    </ul>
  </div>
</billing-dialog>
</template>
<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.zoom-email-calendar-details {
  &.zbo-dialog {
    width: 520px;
    padding: 72px 0;
    .zoom-email-calendar-details__content {
      padding: 0 60px;
    }
  }
  &.zbo-dialog.opc-modal-dialog {
    padding: 28px !important;
  }
  .zbo-dialog__header {
    padding: 0;
  }
  .zbo-dialog__body {
    padding: 0;
  }
  .zbo-dialog__body.is-lost-footer {
    margin: 0;
  }
}
.zoom-email-calendar-details__logo {
  margin-bottom: 4px;
}

.zoom-email-calendar-details__title {
  color: var(--zoom-color-text-subtler-neutral, #666487);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  margin-bottom: 15px;
}

.zoom-email-calendar-details__features {
  list-style: none;
  padding: 0;
  margin-top: 15px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.zoom-email-calendar-details__feature {
  position: relative;
  padding-left: 26px;
  color: var(--light-foreground-foreground, #00053D);
  font-family: 'Almaden Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    background-image: var(--feature-check-url);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 0 0;
  }
}
</style>
